import src from "IMAGE";
export default { src, width: 1454, height: 352, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAMklEQVR42i3KuwkAIBRD0beDheKnUAvncP+h4hVSHALhhqSLhYGJjW4nHPwzoaB5K/IDi00x58YgwE0AAAAASUVORK5CYII="};
